import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {isVendorExcludedFromHidePrices} from "./is_vendor_excluded_from_hide_prices";

export interface IGetShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

export const getShowPrice = ({offerPriceVisibility, vendorPriceVisibility, vendorId}: IGetShowPriceParams) => {
    if (!offerPriceVisibility || !vendorPriceVisibility) {
        return false;
    }

    const offerPriceVisibilityAlways = offerPriceVisibility === PriceVisibilityType.ALWAYS;
    const offerPriceVisibilityAuto = offerPriceVisibility === PriceVisibilityType.AUTO;
    const vendorPriceVisibilityAlways = vendorPriceVisibility === PriceVisibilityType.ALWAYS;
    // INFO: For now remove price visibility based on property.show_price - because with this logic we are not able to hide price in base AB test variant.

    const priceVisibleOnVendor = offerPriceVisibilityAuto && vendorPriceVisibilityAlways;

    const _showPrice = offerPriceVisibilityAlways || priceVisibleOnVendor;

    // If vendor is excluded from hiding prices, always show prices according to original logic
    if (vendorId && isVendorExcludedFromHidePrices(vendorId)) {
        return true;
    }

    // TODO: currently all prices should already be visible, util is necessary to meet common conditions for hiding/showing prices.
    // Since showPrice can cause problems when the price is unknown, I'm changing the default value to `true` for now, until we refactor it to return the correct value.
    return true;
};
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {isVendorExcludedFromHidePrices} from "./is_vendor_excluded_from_hide_prices";

export interface IGetShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

export const getShowPrice = ({offerPriceVisibility, vendorPriceVisibility, vendorId}: IGetShowPriceParams) => {
    if (!offerPriceVisibility || !vendorPriceVisibility) {
        return false;
    }

    const offerPriceVisibilityAlways = offerPriceVisibility === PriceVisibilityType.ALWAYS;
    const offerPriceVisibilityAuto = offerPriceVisibility === PriceVisibilityType.AUTO;
    const vendorPriceVisibilityAlways = vendorPriceVisibility === PriceVisibilityType.ALWAYS;
    // INFO: For now remove price visibility based on property.show_price - because with this logic we are not able to hide price in base AB test variant.

    const priceVisibleOnVendor = offerPriceVisibilityAuto && vendorPriceVisibilityAlways;

    const _showPrice = offerPriceVisibilityAlways || priceVisibleOnVendor;

    // If vendor is excluded from hiding prices, always show prices according to original logic
    if (vendorId && isVendorExcludedFromHidePrices(vendorId)) {
        return true;
    }

    // TODO: currently all prices should already be visible, util is necessary to meet common conditions for hiding/showing prices.
    // Since showPrice can cause problems when the price is unknown, I'm changing the default value to `true` for now, until we refactor it to return the correct value.
    return true;
};
